<template>
  <!-- these two columns need to be animated -->
  <div 
    data-aos="fade-up"
    data-aos-offset="350"
    data-aos-delay="30"
    data-aos-duration="800"
  >
    <v-row no-gutters class="mt-10">
      <!-- <div> -->
      <v-col cols="12" sm="6" :class="`d-flex align-center`">
        <!-- <div data-aos="fade-in"> -->
        <v-img :src="image" class="image-project-responsive" contain :height="styles.imageHeight" />
        <!-- <p>Project description</p> -->
        <!-- </div> -->
      </v-col>
      <v-col cols="12" sm="6" :class="`d-flex align-center justify-center justify-sm-start`">
        <div
          :class="`text-${styles.textJustifiedC} text-sm-${styles.textJustified}`"
          style="padding:20px 30px"
        >
          <h2>{{ info.projectName }}</h2>
          <p>{{ info.duration }}</p>
          <p>Project description</p>
          <p class="mb-0">Tech Stack: {{ info.techStack }}</p>
          <p class="mb-0">Infra Stack: {{ info.infraStack }}</p>
          <p>{{ info.extraInfo }}</p>
          <!-- <a :href="url" target="_blank" class="view-project"> -->
          <a :href="url" target="_blank" class="view-project">View Project</a>
        </div>
      </v-col>
      <!-- </div> -->
    </v-row>
  </div>
</template>

<script>
export default {
  name: "ProjectStartup",
  data: () => ({}),
  components: {},
  props: {
    image: String,
    info: Object,
    styles: Object,
    url: String
  }
};
</script>

<style>
.view-project {
  color: #63c0fa !important;
  transition: all 0.2s ease-out;
  outline: none;
  text-decoration: none;
}
.view-project:hover {
  color: #0666c6 !important;
  transition: all 0.2s ease-out;
}
</style>